module.exports = __webpack_public_path__ + "static/img/ll2.941fdf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/challenge/ll2.png
// module id = Takp
// module chunks = 1